import { type FloatingPosition, Badge, HoverCard, Text } from "@mantine/core";
import type { ReactNode } from "react";
import { type SiteName, SiteNamesWithOptinodeSupport } from "../utils/enums";
import { AnchorLink } from "./AnchorLink/AnchorLink";

declare const SITE_NAME: SiteName;

interface IconBetaFeatureProps {
  className?: string;
  tooltipContent?: ReactNode;
  tooltipMaxWidth?: number;
  tooltipPosition?: FloatingPosition;
}
function IconBetaFeature({
  tooltipMaxWidth,
  tooltipPosition = "bottom"
}: IconBetaFeatureProps) {
  const betaFeatureBadge = (
    <Badge color="warning" size="sm">
      Beta-Feature
    </Badge>
  );

  return (
    <HoverCard
      position={tooltipPosition}
      width={tooltipMaxWidth || 400}
      withArrow
    >
      <HoverCard.Target>{betaFeatureBadge}</HoverCard.Target>
      <HoverCard.Dropdown>
        <Text fw={300} size="sm">
          Diese Funktion befindet sich derzeit in der Betaphase. Sie kann sich
          noch ändern oder eingeschränkte Funktionalität bieten. {SITE_NAME}
          {SiteNamesWithOptinodeSupport.includes(SITE_NAME) && (
            <>
              Wir freuen uns über Ihr Feedback an{" "}
              <AnchorLink href="mailto:support@node.energy" target="_self">
                support@node.energy
              </AnchorLink>
              , um die Funktion vor der offiziellen Veröffentlichung zu
              verbessern.
            </>
          )}
        </Text>
      </HoverCard.Dropdown>
    </HoverCard>
  );
}

export { IconBetaFeature };
